module.exports = __webpack_public_path__ + "img/13-SPOLVERINO-BELEN-U-COLORI-GARZA-STAMPE-VOILE3.c93009b8.jpg";